import type { SkillData } from '../components/SkillCard';

export const seedSkills: SkillData[] = [
  {
    _id: 'seed-1',
    name: 'code-reviewer',
    owner: 'anthropic',
    description: 'Reviews pull requests for safety, style, and structural issues before merge. Use when the user asks to "review this PR" or "audit these changes".',
    installCount: 12480,
    starCount: 312,
    compatibleAgents: ['claude-code', 'cursor', 'codex'],
    categories: ['engineering'],
    tags: ['review', 'quality'],
  } as SkillData,
  {
    _id: 'seed-2',
    name: 'skill-creator',
    owner: 'anthropic',
    description: 'Interactive guide for building new Claude skills. Walks the user through use cases, frontmatter, and validation. Use when the user says "create a skill" or "help me build a skill".',
    installCount: 9210,
    starCount: 287,
    compatibleAgents: ['claude-code'],
    categories: ['productivity'],
    tags: ['scaffold', 'guide'],
  } as SkillData,
  {
    _id: 'seed-3',
    name: 'frontend-design',
    owner: 'anthropic',
    description: 'Creates production-grade frontend interfaces with strong visual design. Use when building components, pages, posters, or web artifacts.',
    installCount: 8740,
    starCount: 263,
    compatibleAgents: ['claude-code', 'cursor', 'windsurf'],
    categories: ['design'],
    tags: ['frontend', 'ui'],
  } as SkillData,
  {
    _id: 'seed-4',
    name: 'pdf-generator',
    owner: 'anthropic',
    description: 'Generates polished PDFs from markdown or structured data. Use when the user asks to "make a PDF", "export a report", or mentions printable output.',
    installCount: 6510,
    starCount: 198,
    compatibleAgents: ['claude-code'],
    categories: ['documents'],
    tags: ['pdf', 'export'],
  } as SkillData,
  {
    _id: 'seed-5',
    name: 'sentry-code-review',
    owner: 'sentry',
    description: 'Analyzes and fixes detected bugs in GitHub pull requests using Sentry error data. Use when the user asks to triage a bug or wants automated PR analysis.',
    installCount: 5320,
    starCount: 174,
    compatibleAgents: ['claude-code'],
    categories: ['engineering'],
    tags: ['sentry', 'debugging'],
  } as SkillData,
  {
    _id: 'seed-6',
    name: 'linear-sprint-planner',
    owner: 'linear',
    description: 'Plans sprints in Linear with capacity analysis, task creation, and labelling. Use when the user says "plan this sprint", "create sprint tasks", or mentions Linear workflows.',
    installCount: 4180,
    starCount: 142,
    compatibleAgents: ['claude-code', 'cursor'],
    categories: ['project-management'],
    tags: ['linear', 'sprint'],
  } as SkillData,
  {
    _id: 'seed-7',
    name: 'figma-handoff',
    owner: 'figma',
    description: 'Generates developer handoff documentation from Figma files including specs and asset manifests. Use when the user uploads .fig files or mentions design handoff.',
    installCount: 3640,
    starCount: 128,
    compatibleAgents: ['claude-code'],
    categories: ['design'],
    tags: ['figma', 'handoff'],
  } as SkillData,
  {
    _id: 'seed-8',
    name: 'docx-creator',
    owner: 'anthropic',
    description: 'Creates Word documents with structured headings, tables, and styles. Use when the user asks to "make a Word doc", "export to .docx", or needs formatted reports.',
    installCount: 2980,
    starCount: 109,
    compatibleAgents: ['claude-code'],
    categories: ['documents'],
    tags: ['docx', 'office'],
  } as SkillData,
];
